import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LocationFilters = ({ activeFilter, onFilterChange, onClearFilters }) => {
  const filters = [
    { id: 'all', label: 'All Locations', icon: 'MapPin' },
    { id: 'open', label: 'Open Now', icon: 'Clock' },
    { id: 'parking', label: 'Parking Available', icon: 'ParkingCircle' },
    { id: 'wifi', label: 'Free WiFi', icon: 'Wifi' },
    { id: 'delivery', label: 'Delivery', icon: 'Truck' }
  ];

  return (
    <div className="bg-[var(--color-card)] rounded-xl p-6 border border-[var(--color-border)]">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-[var(--color-foreground)]">Filter Locations</h3>
        {activeFilter !== 'all' && (
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear
          </Button>
        )}
      </div>
      <div className="space-y-2">
        {filters?.map((filter) => (
          <button
            key={filter?.id}
            onClick={() => onFilterChange(filter?.id)}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-300 ${
              activeFilter === filter?.id
                ? 'bg-[var(--color-primary)] text-[var(--color-primary-foreground)] shadow-md'
                : 'bg-[var(--color-muted)] text-[var(--color-foreground)] hover:bg-[var(--color-primary)]/10'
            }`}
          >
            <Icon
              name={filter?.icon}
              size={20}
              color={activeFilter === filter?.id ? 'var(--color-primary-foreground)' : 'var(--color-primary)'}
            />
            <span className="text-sm font-medium">{filter?.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LocationFilters;